<template>
    <section>
        <div>
            <b-container class="p-0 mb-4" fluid>
                <b-row>
                    <b-col sm="6">
                        <label>Modifier Group Name</label>
                        <b-input-group>
                            <b-input v-model="CategoryComment" name="Modifier Group Name" v-validate="'required'"/>
                        </b-input-group>
                        <p class="mb-0 text-danger" v-if="duplicateNameText !== null">{{duplicateNameText}}</p>
                    </b-col>
                    <b-col sm="6">
                        <label>Applies to</label>
                        <b-input-group>
                            <b-select v-model="ModifierType" disabled name="ModifierType" v-validate="'required'" :options="ModifierTypes"/>
                        </b-input-group>
                    </b-col>
                    <b-col sm="12" class="my-3">
                        <b-form-group label="Type : ">
                            <b-form-radio-group
                                    v-model="IsOptional"
                                    :options="IsOptionals"
                                    name="radio-inline"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <p class="font-weight-bold">
                            Define a rule for how many modifier options to choose
                        </p>
                    </b-col>
                    <b-col sm="12" md="6">
                        <label>Rule Type</label>
                        <b-input-group>
                            <b-select v-model="ChoiceOption"  name="Rule Type" v-validate="'required'" :options="ChoiceOptions"/>
                        </b-input-group>
                        <p v-if="disableSend" class="my-2 text-danger">Please define the rule type and rule number</p>
                    </b-col>
                    <b-col sm="12" md="6">
                        <label>Rule Number</label>
                        <b-input-group>
                            <b-input v-model="ChoiceNumber" name="Rule Number"  v-validate="'required|min_value: 1'" type="number"/>
                        </b-input-group>
                    </b-col>
                    <b-col sm="12">
                        <b-alert :show="errors.any()" variant="danger" class="px-4 my-3">
                            <ul class="m-0 px-1">
                                <li v-for="err in errors.all()" :key="err">{{err}}</li>
                            </ul>
                        </b-alert>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <b-row class="flex-grow-1">
            <b-col cols="4">
                <b-btn variant="warning" block class="text-nowrap" :disabled="loading || disableSend" @click="submitForm">
                    <span v-if="!loading">Submit</span>
                    <font-awesome-icon v-else spin icon="circle-notch" class="align-middle"/>
                </b-btn>
            </b-col>
            <b-col cols="4">
                <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="progressing" @click="closeEditModifierGroup">
                    Cancel
                </b-btn>
            </b-col>
            <b-col cols="4">
                <b-btn variant="danger" block class="text-nowrap" @click="deleteModifierGroup">
                    Delete Modifier Group
                </b-btn>
            </b-col>
        </b-row>
    </section>
</template>

<script>
    export default {
        name: "editModifierGroup",
        props: {
            selectedModifierGroup: {
                required: true
            },
            SelectedModifierCategoryName: {
                required: true
            }
        },
        mounted() {
            let model = {...this.selectedModifierGroup}
            this.CategoryComment = model.ModifierCategory
            this.IsOptional = model.IsOptional
            this.ChoiceNumber = model.ChoiceNumber
            this.ChoiceOption = model.ChoiceOption
            this.ModifierType = model.ModifierType
            this.ModifierCategoryID = model.ModifierCategoryID
        },
        data () {
            return {
                orginalName: this.SelectedModifierCategoryName,
                ModifierTypes: [
                    { value: 'Food', text: 'Food' },
                    { value: 'Drink', text: 'Drink' },
                ],
                ModifierType: 'Food',
                IsOptional : 1,
                IsOptionals: [
                    { text: 'Optional', value: 1 },
                    { text: 'Required', value: 0 },
                ],
                ChoiceOptions: [
                    { text: 'Select Rule Type', value: null },
                    { text: 'Minimum', value: 'Minimum' },
                    { text: 'Maximum', value: 'Maximum' },
                    { text: 'Exactly', value: 'Exactly' },
                ],
                CategoryComment: null,
                ChoiceOption: null,
                ChoiceNumber: 1,
                ModifierCategoryID: null,
                loading: false,
                duplicateNameText: null
            }
        },
        computed: {
            disableSend () {
                if (this.IsOptional === 0 && this.ChoiceOption === 'None') {
                    return true
                } else {
                    return false
                }
            },
            validationRuleNumber () {
                if (this.IsOptional === 0) {
                    return {
                        required: true,
                        decimal: true,
                        min_value: 0
                    }
                } else if (this.ChoiceOption !== 'None') {
                    return {
                        required: true,
                        decimal: true,
                        min_value: 0
                    }
                } else {
                    return {
                        required: false,
                        decimal: true,
                        min_value: 0
                    }
                }
            }
        },
        methods: {
            submitForm () {
                this.getDupplicate().then(response => {
                    if (this.orginalName === this.CategoryComment) {
                        this.$validator.validateAll().then(res => {
                            if (res) {
                                this.duplicateNameText = null
                                let model = {
                                    // UserID: localStorage.getItem('userID'),
                                    RestaurantID: this.$store.state.selectedRestaurantId,
                                    ModifierID: 0,
                                    CategoryDESC: this.CategoryComment,
                                    ChoiceNumber: this.ChoiceNumber,
                                    ChoiceOption: this.ChoiceOption,
                                    IsOptional: this.IsOptional,
                                    ModifierType: this.ModifierType,
                                    CategoryID: this.ModifierCategoryID
                                }
                                this.loading = true
                                this.$api.getRestaurant.UpdateInsertCategoryModifier(model).then(res => {
                                    if (res.success) {
                                        this.loading = false
                                        this.$emit('completeEdit', false)
                                    } else {
                                        this.loading = false
                                        this.$showError(res.message)
                                    }
                                }).catch(() => {
                                    this.loading = false
                                })
                            }
                        })
                    }
                    else {
                        if (!response) {
                            this.$validator.validateAll().then(res => {
                                if (res) {
                                    this.duplicateNameText = null
                                    let model = {
                                        // UserID: localStorage.getItem('userID'),
                                        RestaurantID: this.$store.state.selectedRestaurantId,
                                        ModifierID: 0,
                                        CategoryDESC: this.CategoryComment,
                                        ChoiceNumber: this.ChoiceNumber,
                                        ChoiceOption: this.ChoiceOption,
                                        IsOptional: this.IsOptional,
                                        ModifierType: this.ModifierType,
                                        CategoryID: this.ModifierCategoryID
                                    }
                                    this.loading = true
                                    this.$api.getRestaurant.UpdateInsertCategoryModifier(model).then(res => {
                                        if (res.success) {
                                            this.loading = false
                                            this.$emit('completeEdit', false)
                                        } else {
                                            this.loading = false
                                            this.$showError(res.message)
                                        }
                                    }).catch(() => {
                                        this.loading = false
                                    })
                                }
                            })
                        } else {
                            this.duplicateNameText = 'This is a duplicate name'
                        }
                    }
                    // if (!response) {
                    //
                    // }
                    // else {
                    //
                    // }
                })

            },
            closeEditModifierGroup () {
                this.$emit('closeModifierGroup', false)
            },
            getDupplicate () {
                // check duplicate name of modifier group
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    ModifierType: this.ModifierType,
                    CategoryName: this.CategoryComment,
                    CategoryID: this.ModifierCategoryID,
                }
                return this.$api.getRestaurant.GetIsDuplicateModifierCategory(model).then(res => {
                    return res.results
                })
            },
            deleteModifierGroup () {
                this.$showConfirm(undefined, 'Are You Sure To Remove This Item??').then(() => {
                    let model = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        CategoryID: this.ModifierCategoryID,
                        ModifierType: this.ModifierType
                    }
                    this.$api.getRestaurant.UpdateDelModifierCategory(model).then(() => {
                        this.$emit('completeEdit', false)
                    })
                })
            }
        }
    }
</script>

<style scoped>

</style>
